<breadcrumb [items]="breadcrumb" />
<div class="d-flex align-items-center justify-content-between mb-2">
    <h1 class="mb-0">Médicos</h1>
    <button class="btn btn-primary" [routerLink]="['/doctors/new']">Novo Médico</button>
</div>
<div class="container mb-2 m-0 p-0 col-lg-4">
    <div class="input-group input-group-sm">
        <input id="texto" type="text" class="form-control" placeholder="Busque médicos por nome, e-mail ou CRM" [(ngModel)]="filtro"/>
        <button class="btn btn-outline-secondary" type="button" (click)="filterDoctors()">
            <i class="bi bi-search"></i>
        </button>
    </div>
</div>
<div class="table-responsive">
    <ng-generate-table tableClass="table table-hover border-top" [loading]="loading.main" [columns]="columns" [data]="doctors" />
</div>

<div class="my-3" *ngIf="!loading.main && pagination.total">
    <pagination [total]="pagination.total" [page]="pagination.page" [pageSize]="pagination.pageSize"
        (change)="getAll($event)" (first)="getAll($event)" (last)="getAll($event)">
    </pagination>
</div>

<ng-template #deleteFooter>
    <div class="container-fluid">
        <div class="row row-cols-4 justify-content-end">
            <button type="button" class="btn btn-light me-2" (click)="closeModal()">Cancelar</button>
            <button type="button" class="btn btn-danger" (click)="deleteDoctor()" [disabled]="loading.modal">
                <div class="spinner-border spinner-border-sm" role="status" *ngIf="loading.modal"></div>
                <span *ngIf="!loading.modal">Apagar</span>
            </button>
        </div>
    </div>
</ng-template>